module.exports = __webpack_public_path__ + "img/Photo_4__Second_Welland_Canal_986_82_240.e4d5e2a5.jpg";